((app) => {
    app.provider("dataFeedApi", [function () {
        this.$get = [
            "dataFeedApiGateway", (dataFeedApiGateway) => {
                let service = {};

                service.checkAccess = () => {
                    return dataFeedApiGateway.get("/Policies/AccessCheck");
                };

                service.getPolicies = (search, carrierName, productName, productType, nextPageToken) => {
                    var params = {
                        search: search,
                        carrierName: carrierName,
                        productName: productName,
                        productType: productType
                    };
                    if (nextPageToken)
                        params.token = nextPageToken;
                    return dataFeedApiGateway.get("/Policies", { params: params });
                };

                service.getAllCarrierNames = (search, productName, productType) => {
                    var params = {
                        search: search,
                        productName: productName,
                        productType: productType
                    };
                    return dataFeedApiGateway.get("/Policies/CarrierNames", { params: params });
                };

                service.getAllProductNames = (search, carrierName, productType) => {
                    var params = {
                        search: search,
                        carrierName: carrierName,
                        productType: productType
                    };
                    return dataFeedApiGateway.get("/Policies/ProductNames", { params: params });
                };

                service.getAllProductTypes = (search, carrierName, productName) => {
                    var params = {
                        search: search,
                        carrierName: carrierName,
                        productName: productName
                    };
                    return dataFeedApiGateway.get("/Policies/ProductTypes", { params: params });
                };

                service.getLatestPolicies = (nextPageToken) => {
                    var params = {};
                    if (nextPageToken)
                        params.token = nextPageToken;
                    return dataFeedApiGateway.get("/Policies/Latest", { params: params });
                };

                service.getPolicyDetails = (mappedPolicyId) => {
                    return _getRouteFactory(mappedPolicyId);
                };

                service.getAgentAdditional = (mappedPolicyId, transientMappedPersonId) => {
                    return _getRouteFactory(mappedPolicyId + "/AgentDetails", { params: { transientMappedPersonId: transientMappedPersonId } });
                };

                service.getUplineAdditional = (mappedPolicyId, transientMappedEntityId) => {
                    return _getRouteFactory(mappedPolicyId + "/UplineDetails", { params: { transientMappedEntityId: transientMappedEntityId } });
                };

                service.getRelatedPeopleAdditional = (mappedPolicyId, transientMappedPersonId) => {
                    return _getRouteFactory(mappedPolicyId + "/RelatedPersonDetails", { params: { transientMappedPersonId: transientMappedPersonId } });
                };

                service.getRelatedEntitiesAdditional = (mappedPolicyId, transientMappedEntityId) => {
                    return _getRouteFactory(mappedPolicyId + "/RelatedEntityDetails", { params: { transientMappedEntityId: transientMappedEntityId } });
                };

                service.getRequirementsAdditional = (mappedPolicyId, grouping, num) => {
                    return _getRouteFactory(mappedPolicyId + "/RequirementDetails", { params: { grouping: grouping, num: num } });
                };

                service.getPolicyValues = (mappedPolicyId) => {
                    return _getRouteFactory(mappedPolicyId + "/PolicyValues");
                };

                service.getPolicyStages = (mappedPolicyId) => {
                    return _getRouteFactory(mappedPolicyId + "/PolicyStages");
                };

                service.getFundings = (mappedPolicyId) => {
                    return _getRouteFactory(mappedPolicyId + "/Fundings");
                };

                service.getFundingsAdditional = (mappedPolicyId, grouping, num) => {
                    return _getRouteFactory(mappedPolicyId + "/FundingDetails", { params: { grouping: grouping, num: num } });
                };

                service.getServiceFeatures = (mappedPolicyId) => {
                    return _getRouteFactory(mappedPolicyId + "/ServiceFeatures");
                };

                service.getServiceFeaturesAdditional = (mappedPolicyId, grouping, num) => {
                    return _getRouteFactory(mappedPolicyId + "/ServiceFeatureDetails", { params: { grouping: grouping, num: num } });
                };

                service.getFundAllocations = (mappedPolicyId) => {
                    return _getRouteFactory(mappedPolicyId + "/FundAllocations");
                };

                service.getFundAllocationsAdditional = (mappedPolicyId, grouping, num) => {
                    return _getRouteFactory(mappedPolicyId + "/FundAllocationDetails", { params: { grouping: grouping, num: num } });
                };

                service.getFinancialTransactions = (mappedPolicyId) => {
                    return _getRouteFactory(mappedPolicyId + "/FinancialTransactions");
                };

                service.getFinancialTransactionsAdditional = (mappedPolicyId, grouping, num) => {
                    return _getRouteFactory(mappedPolicyId + "/FinancialTransactionDetails", { params: { grouping: grouping, num: num } });
                };

                service.getInforceFinancialTransactions = (mappedPolicyId) => {
                    return _getRouteFactory(mappedPolicyId + "/InforceFinancialTransactions");
                };

                function _getRouteFactory(relativeUrl, params) {
                    return dataFeedApiGateway.get("/Policies/" + relativeUrl, params);
                }

                return service;
            }
        ];
    }
    ]);
})(window.app); //jshint ignore:line